import api from '@motionelements/core/src/api/base-api-v2';
import { snakeCaseKeys } from '@motionelements/core/src/helpers/string';
import { STUDIO_AI_API_VERSION } from '@/constants';

export const generatePredictions = async (payload, params, axiosConfig) => {
  const post = await api.request('post', `/${STUDIO_AI_API_VERSION}/predictions`, {
    ...(axiosConfig || {}), // for recaptcha headers
    data: payload,
    params: {
      ...api.getLocaleParams(),
      ...params,
    },
  });
  return post;
};

export const getPredictions = async (params, axiosConfig) => {
  params = params || {};
  const config = {
    params: {
      ...api.getLocaleParams(),
      ...snakeCaseKeys(params),
    },
    ...(axiosConfig || {}),
  };

  return api.request('get', `/${STUDIO_AI_API_VERSION}/predictions`, config);
};

export const createStripeCheckoutUrl = async (payload, axiosConfig) => {
  const post = await api.request('post', `/${STUDIO_AI_API_VERSION}/checkout`, {
    ...(axiosConfig || {}), // for recaptcha headers
    data: payload,
    params: api.getLocaleParams(),
  });
  return post;
};

export const createStripeBillingPortalUrl = async (payload, axiosConfig) => {
  const post = await api.request('post', `/${STUDIO_AI_API_VERSION}/billing-portal`, {
    ...(axiosConfig || {}), // for recaptcha headers
    data: payload,
    params: api.getLocaleParams(),
  });
  return post;
};

export const checkoutSuccess = async (payload, axiosConfig) => {
  const post = await api.request('post', `/${STUDIO_AI_API_VERSION}/checkout/success`, {
    ...(axiosConfig || {}), // for recaptcha headers
    data: payload,
  });
  return post;
};

export const getPrediction = async (id) => {
  const request = await api.get(`/${STUDIO_AI_API_VERSION}/predictions/${id}`);
  return request;
};

export const getPredictionEstimate = async (payload, axiosConfig) => {
  const config = {
    data: {
      ...payload,
    },
    ...(axiosConfig || {}),
  };
  return api.request('post', `/${STUDIO_AI_API_VERSION}/predictions/estimate`, config);
};

/*
export const cancelPrediction = async (id) => {
  const request = await api.request('delete', `/${STUDIO_AI_API_VERSION}/predictions/${id}`);
  return request;
};
 */
